import { render, staticRenderFns } from "./TrainingCenterItem.vue?vue&type=template&id=6ff7b469&scoped=true&"
import script from "./TrainingCenterItem.vue?vue&type=script&lang=js&"
export * from "./TrainingCenterItem.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenterItem.vue?vue&type=style&index=0&id=6ff7b469&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff7b469",
  null
  
)

export default component.exports